import { React, useState, useEffect, View, useRef } from 'react';
import { Box, Paper, Typography, Button, FormControl, InputLabel, Select, MenuItem, OutlinedInput } from "@mui/material";
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import draftToHtml from "draftjs-to-html";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export default function AddForumOverlay({ onClose, handleSubmit, input_post, forum_title, tags }) {
  const [title, setTitle] = useState(forum_title != undefined ? forum_title : "");
  const [post, setPost] = useState(input_post != undefined ? input_post : "");
  const [selectedTag, setSelectedTag] = useState("");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const handleEditorChange = (state) => {
    setEditorState(state);
  };

  useEffect(() => {
    if (post != "") {
      const blocksFromHTML = convertFromHTML(post);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorState(EditorState.createWithContent(contentState));
    }
  }, [post]);

  const handleTagChange = (event) => {
    setSelectedTag(event.target.value);
  };

  const handleSubmitForm = () => {
    const contentState = editorState.getCurrentContent();
    const rawContent = convertToRaw(contentState);
    let html = draftToHtml(rawContent);
    html = html.replace("\n", "<br/>");

    // Pass selected tag as array with single element
    handleSubmit(title, html, selectedTag ? [selectedTag] : []);
    onClose();
  };

  // Filter tags to only show "Trustee" and "General"
  const tagsList = Object.values(tags || {}).filter(tag => {
    const tagName = tag.attributes?.name?.toLowerCase();
    return tagName === 'trustee' || tagName === 'general';
  });

  // Set default tag if available and not already set
  useEffect(() => {
    if (!selectedTag && tagsList.length > 0) {
      const generalTag = tagsList.find(t => t.attributes?.name?.toLowerCase() === 'general');
      if (generalTag) {
        setSelectedTag(generalTag.id);
      } else {
        setSelectedTag(tagsList[0].id);
      }
    }
  }, [tagsList, selectedTag]);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        bgcolor: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
      }}
    >
      <Paper sx={{ p: 4, minWidth: 500, minHeight: 150, position: 'relative' }} elevation={8}>
        <Button
          variant="outlined"
          size="small"
          sx={{ position: 'absolute', top: 16, right: 16 }}
          onClick={onClose}
        >
          Close
        </Button>
        <div style={{ paddingTop: 20 }}>
          <input
            placeholder="Title"
            className="input-rounded"
            value={title}
            onChange={e => setTitle(e.target.value)}
            style={{ width: '100%', marginBottom: 16 }}
          />

          {/* Tag Selection - Single Select */}
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="tag-label">Select Category</InputLabel>
            <Select
              labelId="tag-label"
              value={selectedTag}
              onChange={handleTagChange}
              input={<OutlinedInput label="Select Category" />}
              sx={{
                '& .MuiSelect-select': {
                  color: '#00aaaf'
                }
              }}
            >
              {tagsList.map((tag) => (
                <MenuItem
                  key={tag.id}
                  value={tag.id}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: '#e7f4f6',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: '#d0e8ea',
                    }
                  }}
                >
                  {tag.attributes?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Editor
            editorState={editorState}
            onEditorStateChange={handleEditorChange}
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
            placeholder="Enter Post"
            editorStyle={{
              height: '300px',
              overflow: 'auto',
              border: "1px solid #ccc",
              padding: 10,
              marginBottom: 16
            }}
          />

          <div style={{ paddingBottom: 10 }}>
            <Button
              onClick={handleSubmitForm}
              style={{
                backgroundColor: "#00aaaf",
                borderColor: "#00aaaf",
                color: "#fff"
              }}
              className="chat-rounded2"
              disabled={!title.trim() || !editorState.getCurrentContent().hasText() || !selectedTag}
            >
              Add Discussion
            </Button>
          </div>
        </div>
      </Paper>
    </Box>
  );
}